import { number, string } from 'prop-types';
import React from 'react';

import ShareInput from '../../../generic/ShareInput';
import { calculateShare } from '../calculate-derived-values';

function DerivedShareInput({ value, budgetTotal, name, ...rest }) {
  return (
    <ShareInput
      value={calculateShare(value, budgetTotal)}
      name={name}
      readOnly
      {...rest}
    />
  );
}

DerivedShareInput.propTypes = {
  value: number.isRequired,
  budgetTotal: number.isRequired,
  name: string,
};

DerivedShareInput.defaultProps = {
  name: '',
};

export default DerivedShareInput;
